import { motion } from "framer-motion";
import { Delete } from "lucide-react";

const KEYBOARD_ROWS = [
  ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
  ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
  ["ENTER", "Z", "X", "C", "V", "B", "N", "M", "BACKSPACE"],
];

const Keyboard = ({ onKeyPress, keyStates, disabled }) => {
  const getKeyClass = (key) => {
    const state = keyStates[key];
    
    let bgClass = "bg-dark-subtle hover:bg-white/20";
    let textClass = "text-text-primary";
    
    if (state === "correct") {
      bgClass = "bg-game-correct hover:bg-game-correct/80";
    } else if (state === "present") {
      bgClass = "bg-game-present hover:bg-game-present/80";
    } else if (state === "absent") {
      bgClass = "bg-game-absent hover:bg-game-absent/80";
      textClass = "text-text-muted";
    }
    
    return `${bgClass} ${textClass}`;
  };

  return (
    <div className="w-full max-w-lg mx-auto" data-testid="keyboard">
      {KEYBOARD_ROWS.map((row, rowIndex) => (
        <div
          key={rowIndex}
          className={`flex justify-center gap-1 mb-1.5 ${
            rowIndex === 1 ? "px-4" : ""
          }`}
        >
          {row.map((key) => {
            const isSpecial = key === "ENTER" || key === "BACKSPACE";
            
            return (
              <motion.button
                key={key}
                onClick={() => !disabled && onKeyPress(key)}
                disabled={disabled}
                className={`
                  keyboard-key
                  ${getKeyClass(key)}
                  ${isSpecial ? "px-3 min-w-[52px]" : "flex-1 max-w-[44px]"}
                  ${disabled ? "opacity-50 cursor-not-allowed" : ""}
                `}
                whileTap={{ scale: 0.95 }}
                data-testid={`key-${key.toLowerCase()}`}
              >
                {key === "BACKSPACE" ? (
                  <Delete className="w-5 h-5" />
                ) : key === "ENTER" ? (
                  <span className="text-xs font-semibold">ENTER</span>
                ) : (
                  key
                )}
              </motion.button>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default Keyboard;
